import React from 'react';
import classNames from 'classnames/bind';
import { arrayOf, string } from 'prop-types';
import { OrderedList } from '@thd-olt-component-react/list';
import styles from './what-to-expect.module.scss';

const cx = classNames.bind(styles);

export const WhatToExpect = ({ whatToExpectList }) => {
  if (!whatToExpectList?.length) {
    return null;
  }
  return (
    <div className={cx('what-to-expect')}>
      <div className={cx('what-to-expect__header')}>What to Expect</div>
      <OrderedList>
        {whatToExpectList.map((listItem, index) => <li key={index}> {listItem} </li>)}
      </OrderedList>
    </div>
  );

};

WhatToExpect.propTypes = {
  whatToExpectList: arrayOf(string)
};

WhatToExpect.defaultProps = {
  whatToExpectList: []
};